<template>
  <div>
    <!--TILE VIEW -->
    <div class="row" v-if="getViewType == CONSTANTS.VIEW_TYPE_TILE">
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 tile"
        v-for="tile in apps" :key="tile.id" >
        <tile :tileModel="tile" :viewId="view.id" :categoryId="category.id"></tile>
      </div>
    </div>
    <!--LIST VIEW -->
    <div class="row" v-else>
      <div class="col-12 table-container">
        <app-table :apps="apps" :columns="columns" :pagination-options="paginationOptions"></app-table>
        
      </div>
    </div>
    <download-modal :model="downloadModel" :viewId="view.id" :categoryId="category.id"
      v-if="downloadModel && downloadModel.root_link.type === CONSTANTS.ROOT_LINK_TYPES.DIRECT_DOWNLOAD"
      v-show="downloadModel && downloadModel.show"
      @close="downloadModel = null"
    />
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'

import AppTable from '@/components/AppTable'
import * as CONSTANTS from '../constants.js'
import Tile from '@/components/Tile'
import util from '@/util'
import AppHandlerMixin from '@/mixins/AppHandlerMixin'

export default {
  name: 'TileContainer',
  components: {
    Tile,
    AppTable
  },
  mixins: [AppHandlerMixin],
  props: {
    apps: Array,
    view: {
      type: Object,
      default: () => { return {} }
    },
    category: {
      type: Object,
      default: () => { return {} }
    }
  },
  data: function () {
    return {
      CONSTANTS,
      columns: [
        {
          label: "Favorite",
          field: "favorite",
          sortFn: util.favoriteSort
        },
        {
          label: 'Title',
          field: 'title'
        },
        {
          label: 'Description',
          field: 'tag_line'
        },
        {
          label: 'Access',
          field: 'access.last_accessed',          
          sortFn: util.accessStateSort
        },
        {
          label: 'Entitlement',
          field: 'access.state',
          sortFn: util.entitlementSort
        },
        {
          label: 'Link',
          field: 'root_link',
          sortable: false
        }
      ],
      paginationOptions: {
        enabled: false
      },
      downloadModel: null
    }
  },
  computed: {
    ...mapGetters(['getViewType', 'getApplications', 'getApplicationById'])
  },
  mounted () {},
  methods: {
    setModel(model) {
      this.downloadModel = this.getApplicationById(model.id);
      this.downloadModel.show = true;
    }
  }
}
</script>
<style scoped>

h3 {
  font-weight: bold;
  font-size: 25px;
  color: #575757;
  margin-top: 20px;
}
.tile {
  margin-bottom : 25px;
  padding-right: 8px;
  padding-left: 8px;
}
.has-access-container svg{
  width: 7px;
  float: left;
  color: #7ed321;
}
.has-access-container .access-text {
  font-size: 11px;
  color: #7ed321;
  float: left;
  padding-right: 5px;
  font-weight: bold;
}
.unknown-access-text {
  font-size: 11px;
  color: #575757;
  font-weight: bold;
}
.table-container {
  margin-bottom: 20px;
}
</style>
